import  { useState } from 'react';
import {
    useTheme,    
    Button,
    Dialog,
    DialogActions,   
    DialogTitle,    
    Box,    
    Typography,
   
} from '@mui/material';


import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { tokens } from '../../theme/theme';

const ConfirmationMessage = ({ open, onClose,message,buttonname,action }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [product, setProduct] = useState('Parent Roll');


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> {/* Add icon with some margin */}
                    <Typography>{message}</Typography>
                </Box>
            </DialogTitle>


            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button size='small' variant="contained" color="secondary" style={{ textTransform: 'none' }} onClick={action}>
                    {buttonname}
                </Button>
                <Button size='small' variant="contained" color="secondary" style={{ textTransform: 'none' }} onClick={onClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationMessage;